import {updateObject} from "../../shared/utils/utils";
import * as actionTypes from "./actionTypes";

const initialState = {
    licenseSummary: {
        companyId: null,
        totalLicenses: null,
        usedLicenses: null,
        licensesLeft: null,
        hasActiveSubscription: null,
        licenseStartTs: null,
        licenseEndTs: null,
        graceEndTs: null,
        licenseStatus: null,
        withinValidityPeriod: null
    },
    loading: false,
    selectedCompanyId: null
}

const setLicenseSummary = (state, action) => {
    return updateObject(state, {
        licenseSummary: action.payload
    })
}

const setLoading = (state, action) => {
    return updateObject(state, {
        loading: action.payload
    })
}

const setSelectedCompanyId = (state, action) => {
    return updateObject(state, {
        selectedCompanyId: action.payload
    })
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_LICENSE_SUMMARY_SUCCESS:
            return setLicenseSummary(state, action);
        case actionTypes.SET_LICENSE_SUMMARY_LOADING:
            return setLoading(state, action);
        case actionTypes.SET_SELECTED_COMPANY_ID:
            return setSelectedCompanyId(state, action);
        default:
            return state;
    }
}
